import { OfflineDatabaseService } from '../offline-database.service';
import { SqliteObjectWrapper } from '../../sqlite-wrapper/sqlite-object-wrapper';
import { OfflineTableName, ensureTable } from '../offline-schema';

/** Pasa el resultado de `executeSql` (`rows.item(i)`) a un arreglo. */
export function rowsOf<T = any>(result: any): T[] {
  const rows: T[] = [];
  for (let i = 0; i < result.rows.length; i++) {
    rows.push(result.rows.item(i));
  }
  return rows;
}

/**
 * Base de los repositorios de la base offline: el SQL de cada tabla vive en su repositorio y las
 * páginas piden métodos con nombre. Los métodos no tragan errores (una tabla que todavía no existe,
 * porque nunca se descargó nada, falla igual que antes); cada llamador decide cómo registrarlos.
 */
export abstract class OfflineRepository {
  constructor(private offlineDb: OfflineDatabaseService) {}

  protected async db(): Promise<SqliteObjectWrapper> {
    const db = await this.offlineDb.get();
    if (!db) throw new Error('La base offline no está disponible');
    return db;
  }

  protected async rows<T = any>(sql: string, params: any[] = []): Promise<T[]> {
    return rowsOf<T>(await (await this.db()).executeSql(sql, params));
  }

  protected async run(sql: string, params: any[] = []): Promise<void> {
    await (await this.db()).executeSql(sql, params);
  }

  /** Crea la tabla si todavía no existe: la descarga las crea al guardar lo primero. */
  protected async ensure(table: OfflineTableName): Promise<void> {
    await ensureTable(await this.db(), table);
  }

  protected async tableExists(table: string): Promise<boolean> {
    return (await this.db()).tableExists(table);
  }
}
